import 'moment/locale/de';
import { config } from "../../config";
import axios from "axios";

export class ReviewsService {
  public async getReviewByRecordTaskId(recordTaskId: string) {
    try {
      const { serverUrl } = config;
      const res = await axios.get(
        serverUrl + "statistics/review/" + recordTaskId,
      );
      return res.data;
    } catch (err) {
      return null;
    }
  }

  public async makeReviewForTask(review: any, recordTaskId: string) {
    try {
      const { serverUrl } = config;
      const res = await axios.put(
        serverUrl + "statistics/review/" + recordTaskId,
        review
      );
      return res.data;
    } catch (err) {
      return null;
    }
  }
}
